<template>
  <div id="chargeForm">
    <div class="common_tit_wrap">
      <div class="common_page_tit">청구
        <template v-if="chargePid != null">수정</template>
        <template v-else>등록</template>
      </div>
    </div>
    <div class="common_form_wrap">
      <div class="common_form_box">
        <div class="common_form_box_tit">청구 기본정보</div>
        <div class="common_form_box_content">
          <div class="common_form_input_wrap one_third_width">
            <label>청구년월<span class="fc_red">*</span></label>
            <div>
              <template v-if="chargePid != null">
                <input type="text" :value="chargeDateStr" readonly/>
              </template>
              <template v-else>
                <vue-datepicker-local
                  v-model="chargeDate"
                  inputClass="vdl_input"
                  :local="ko"
                  format="YYYY-MM"/>
              </template>
            </div>
          </div>
        </div>
        <div class="common_form_box_content">
          <div class="common_form_input_wrap two_third_width">
            <label>청구대상<span class="fc_red">*</span></label>
            <div>
              <template v-if="chargePid != null">
                <input type="text" :value="affiliateCodeName" readonly/>
                <input type="text" :value="officeCodeName" readonly/>
              </template>
              <template v-else>
                <select v-model="affiliateCode">
                  <option value="">미선택</option>
                  <option v-for="item in afcList" :key="'afc_' + item.codePid" :value="item.codeValue">{{item.codeName}}</option>
                </select>
                <select v-model="ofc1Select">
                  <option value="">미선택</option>
                  <option v-for="item in ofc1List" :key="'ofc1_' + item.codePid" :value="item.codeValue">{{item.codeName}}</option>
                </select>
              </template>
            </div>
          </div>
        </div>
      </div>
      <div class="common_form_box">
        <div class="common_form_box_tit">청구 파일 업로드</div>
        <div class="common_form_box_content">
          <div class="common_form_input_wrap type_file">
            <div>
              <div>저압 청구 파일</div>
              <div>
                <template v-if="lowFileOrigin != null && lowFileOrigin.length > 0">{{lowFileOrigin}}</template>
                <template v-else>첨부파일 없음</template>
              </div>
            </div>
            <input type="file" id="low" ref="low" @change="uploadFile('low')"/>
            <label for="low" class="btn_upload">파일 첨부</label>
            <label class="btn_delete" @click="deleteFile('low')" v-if="lowFileOrigin != null && lowFileOrigin.length > 0">첨부 삭제</label>
          </div>
        </div>
        <div class="common_form_box_content">
          <div class="common_form_input_wrap type_file">
            <div>
              <div>고압 청구 파일</div>
              <div>
                <template v-if="highFileOrigin != null && highFileOrigin.length > 0">{{highFileOrigin}}</template>
                <template v-else>첨부파일 없음</template>
              </div>
            </div>
            <input type="file" id="high" ref="high" @change="uploadFile('high')"/>
            <label for="high" class="btn_upload">파일 첨부</label>
            <label class="btn_delete" @click="deleteFile('high')" v-if="highFileOrigin != null && highFileOrigin.length > 0">첨부 삭제</label>
          </div>
        </div>
        <div class="common_form_box_content">
          <div class="common_form_input_wrap type_file">
            <div>
              <div>전선도난 파일</div>
              <div>
                <template v-if="stolenFileOrigin != null && stolenFileOrigin.length > 0">{{stolenFileOrigin}}</template>
                <template v-else>첨부파일 없음</template>
              </div>
            </div>
            <input type="file" id="stolen" ref="stolen" @change="uploadFile('stolen')"/>
            <label for="stolen" class="btn_upload">파일 첨부</label>
            <label class="btn_delete" @click="deleteFile('stolen')" v-if="stolenFileOrigin != null && stolenFileOrigin.length > 0">첨부 삭제</label>
          </div>
        </div>
        <div class="common_form_box_content">
          <div class="common_form_input_wrap type_file">
            <div>
              <div>세금계산성 등 파일</div>
              <div>
                <template v-if="taxFileOrigin != null && taxFileOrigin.length > 0">{{taxFileOrigin}}</template>
                <template v-else>첨부파일 없음</template>
              </div>
            </div>
            <input type="file" id="tax" ref="tax" @change="uploadFile('tax')"/>
            <label for="tax" class="btn_upload">파일 첨부</label>
            <label class="btn_delete" @click="deleteFile('tax')" v-if="taxFileOrigin != null && taxFileOrigin.length > 0">첨부 삭제</label>
          </div>
        </div>
      </div>
      <div class="common_bottom_wrap">
        <div class="btn_bottom btn_blue" @click="saveCharge">저장</div>
      </div>
    </div>
  </div>
</template>

<script>
import VueDatepickerLocal from 'vue-datepicker-local'
import common from '../../script/common'
import axios from 'axios'
import chargeFiles from '../../script/chargeFiles'

export default {
  components: {VueDatepickerLocal},
  data () {
    return {
      // Common
      mySession: {},
      ko: common.getDatepickerLocal(),
      // Return
      searchParams: {},
      // Data
      afcList: [],
      ofcList: [],
      ofc1List: [],
      ofc1Select: '',
      // Modem
      originData: {},
      chargePid: null,
      chargeDate: '',
      chargeDateStr: '',
      affiliateCode: '',
      affiliateCodeName: '',
      officeCodeName: '',
      lowFileOrigin: '',
      lowFile: '',
      highFileOrigin: '',
      highFile: '',
      stolenFileOrigin: '',
      stolenFile: '',
      taxFileOrigin: '',
      taxFile: ''
    }
  },
  mounted () {
    common.getSession(response => {
      if (response.data.resultCode === 1 && response.data.result != null && response.data.result.userPid != null && response.data.result.userRole != null) {
        this.mySession = response.data.result
        let intervalCnt = 0
        let interval = setInterval(() => {
          if (common.checkValidateData('session', sessionStorage.getItem('afcList')) &&
            common.checkValidateData('session', sessionStorage.getItem('ofcList'))) {
            clearInterval(interval)
            this.afcList = JSON.parse(sessionStorage.getItem('afcList'))
            this.ofcList = JSON.parse(sessionStorage.getItem('ofcList'))
            this.ofc1List = this.getOfc1List()
            if (this.$route.params != null) {
              if (this.$route.params.searchParams != null) {
                this.searchParams = this.$route.params.searchParams
              }
              if (this.$route.params.type != null && this.$route.params.type === 'edit') {
                this.updateData()
              }
            }
          } else if (intervalCnt > 10) {
            clearInterval(interval)
            common.amsAlert('retry', '필수 데이터를 불러오지 못했습니다.')
          } else {
            intervalCnt++
          }
        }, 200)
      } else {
        common.amsAlert('general', '로그아웃 되었습니다.\n다시 로그인해주세요.')
        this.$router.replace('/Login')
      }
    })
  },
  methods: {
    getOfc1List () {
      return this.ofcList.filter(item => { return item.codeLevel === 0 })
    },
    updateData () {
      this.originData = this.$route.params.data
      const data = this.$route.params.data
      if (!data.hasOwnProperty('chargePid') || data.chargePid == null) {
        return
      }
      this.chargePid = data.chargePid
      this.chargeDate = ''
      if (data.chargeYear != null && data.chargeMonth != null) {
        this.chargeDateStr = data.chargeYear.toString() + '-' + (data.chargeMonth < 10 ? '0' + data.chargeMonth : data.chargeMonth.toString())
        this.chargeDate = new Date(data.chargeYear.toString() + '-' + (data.chargeMonth < 10 ? '0' + data.chargeMonth : data.chargeMonth.toString()))
      }
      this.affiliateCode = data.affiliateCode != null ? data.affiliateCode : ''
      for (let i = 0; i < this.afcList.length; i++) {
        if (this.afcList[i].codeValue === data.affiliateCode) {
          this.affiliateCodeName = this.afcList[i].codeName
        }
      }
      if (data.officeCode != null && data.officeCode.length > 0) {
        this.ofc1Select = data.officeCode.substring(0, 5)
        for (let i = 0; i < this.ofc1List.length; i++) {
          if (this.ofc1List[i].codeValue === data.officeCode.substring(0, 5)) {
            this.officeCodeName = this.ofc1List[i].codeName
          }
        }
      }
      this.lowFileOrigin = data.lowFile != null ? common.getOriginalFileName(data.lowFile) : ''
      this.lowFile = data.lowFile != null ? data.lowFile : ''
      this.highFileOrigin = data.highFile != null ? common.getOriginalFileName(data.highFile) : ''
      this.highFile = data.highFile != null ? data.highFile : ''
      this.stolenFileOrigin = data.stolenFile != null ? common.getOriginalFileName(data.stolenFile) : ''
      this.stolenFile = data.stolenFile != null ? data.stolenFile : ''
      this.taxFileOrigin = data.taxFile != null ? common.getOriginalFileName(data.taxFile) : ''
      this.taxFile = data.taxFile != null ? data.taxFile : ''
    },
    uploadFile (type) {
      if (!common.checkValidateData('date', this.chargeDate)) {
        common.amsAlert('general', '청구년월을 선택해주세요.')
        return
      }
      if (this.$refs[type].files.length !== 1) {
        common.amsAlert('general', '파일을 선택하세요.')
        return
      }
      const file = this.$refs[type].files[0]
      const fileName = file.name
      if (!common.checkValidateLength('max', fileName, 50)) {
        common.amsAlert('general', '파일명은 50자 이내로 설정하세요.')
        return
      }
      const attachmentTypes = ['low', 'high', 'stolen', 'tax']
      if (attachmentTypes.includes(type)) {
        this[`${type}FileOrigin`] = fileName
      } else {
        common.amsAlert('general', '잘못된 접근입니다.')
      }
      const chargeDate = new Date(this.chargeDate)
      const subPath = chargeDate.getFullYear().toString().slice(2) + (chargeDate.getMonth() + 1 < 10 ? '0' + (chargeDate.getMonth() + 1) : (chargeDate.getMonth() + 1).toString())
      let formData = new FormData()
      formData.append('file', file)
      formData.append('path', 'charge')
      formData.append('subPath', subPath)
      axios.post('/api/uploadFile', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'authorization': sessionStorage.accessToken,
          'authorization-refresh': sessionStorage.accessTokenRefresh
        }
      }).then(response => {
        console.log('uploadFile', response)
        if (response.data.resultCode === 1) {
          if (attachmentTypes.includes(type)) {
            this[`${type}File`] = response.data.result
          } else {
            common.amsAlert('general', '잘못된 접근입니다.')
          }
        } else {
          alert('파일을 업로드하지 못했습니다.\n잠시 후 다시 시도해주세요.')
        }
      }).catch(response => {
        console.error(response)
        alert('파일을 업로드하지 못했습니다.\n잠시 후 다시 시도해주세요.')
      })
    },
    deleteFile (type) {
      const attachmentTypes = ['low', 'high', 'stolen', 'tax']
      if (attachmentTypes.includes(type)) {
        this[`${type}FileOrigin`] = ''
        this[`${type}File`] = ''
      } else {
        common.amsAlert('general', '잘못된 접근입니다.')
      }
    },
    saveCharge () {
      if ((this.mySession.subRole & 32) === 0) {
        common.amsAlert('general', '권한이 없습니다.')
        return
      }
      if (!common.checkValidateData('date', this.chargeDate)) {
        common.amsAlert('general', '청구년월을 선택해주세요.')
        return
      }
      if (!common.checkValidateData('string', this.affiliateCode) ||
        !common.checkValidateData('string', this.ofc1Select)) {
        common.amsAlert('general', '청구대상을 선택해주세요.')
        return
      }
      const chargeDate = new Date(this.chargeDate)
      let data = {
        chargeYear: chargeDate.getFullYear().toString(),
        chargeMonth: chargeDate.getMonth() + 1 < 10 ? '0' + (chargeDate.getMonth() + 1) : (chargeDate.getMonth() + 1).toString(),
        affiliateCode: this.affiliateCode,
        officeCode: this.ofc1Select
      }
      if (common.checkValidateData('string', this.lowFile)) {
        data.lowFile = this.lowFile
      }
      if (common.checkValidateData('string', this.highFile)) {
        data.highFile = this.highFile
      }
      if (common.checkValidateData('string', this.stolenFile)) {
        data.stolenFile = this.stolenFile
      }
      if (common.checkValidateData('string', this.taxFile)) {
        data.taxFile = this.taxFile
      }
      let method = 'put'
      const checkedData = common.checkChangedData(data, this.originData)
      if (this.chargePid != null) {
        method = 'post'
        if (Object.keys(checkedData).length > 0) {
          checkedData.chargePid = this.originData.chargePid
        } else {
          common.amsAlert('general', '수정된 내용이 없습니다.')
          return
        }
      }
      chargeFiles.charge(method, checkedData, response => {
        console.log('[청구 관리]: ' + method, response)
        if (response.data.resultCode === 1) {
          common.amsAlert('general', '청구를 ' + (method === 'put' ? '등록' : '수정') + '했습니다.')
          this.$router.push({
            name: 'ChargeList',
            params: {
              type: 'return',
              searchParams: this.searchParams
            }
          })
        } else {
          common.amsAlert('retry', '청구를 ' + (method === 'put' ? '등록' : '수정') + '하지 못했습니다.')
        }
      })
    }
  }
}
</script>

<style scoped>
#chargeForm {
  display: flex;
  flex-direction: column;
  margin: 36px auto 46px;
}

#chargeForm .common_bottom_wrap > .btn_blue {
  margin: auto 0 auto auto;
}
</style>



// WEBPACK FOOTER //
// src/components/charge/ChargeForm.vue